import { WithColor } from '@styles/colors';
import { NCFileFirstRanInfoType } from '@v2/pages/machines/modules/now/components/Overview/types';

export enum TopBlockVariant {
  CHANGE_OR_IGNORED = 'changeOrIgnored',
  SETUP = 'setup',
  LINKED_OR_UNKNOWN = 'linkedOrUnknown',
}

export interface BaseTopBlockProps extends WithColor {}

export interface NCFileNameProp {
  ncFileName: string;
}

export interface OnTopBlockImagePressProp {
  onTopBlockImagePress: (selectedImageKey: string) => void;
}

export interface OnModifyNCFileTypePressProp {
  onModifyNCFileTypePress: () => void;
}

export interface OnTopBlockPressProp {
  onTopBlockPress?: () => void;
}

export interface NCFileFirstRanInfoProp {
  ncFileFirstRanInfo: NCFileFirstRanInfoType | null;
}
